<template>
  <div class="login_container">
    <div class="login_box">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs_menu">
        <el-tab-pane label="手機號註冊" name="first" v-if="!isForget">
          <el-form
            ref="registerFormRef1"
            :model="registerForm"
            :rules="rules"
            label-width="0"
            class="login_form"
          >
            <el-form-item prop="userPhone">
              <el-input
                v-model="registerForm.userPhone"
                prefix-icon="el-icon-mobile-phone"
                placeholder="請輸入您的手機號"
              ></el-input>
            </el-form-item>
            <el-form-item prop="verifyCode" class="code_input">
              <el-input
                v-model="registerForm.verifyCode"
                prefix-icon="el-icon-key"
                placeholder="請輸入動態密碼"
              ></el-input>

              <div
                class="code_btn"
                v-show="show"
                @click="fnGetVerificationCode(1)"
              >
                獲取驗證碼
              </div>
              <span v-show="!show" class="count">{{ count }}s後重新獲取</span>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="registerForm.password"
                type="password"
                prefix-icon="el-icon-lock"
                placeholder="密碼以字母開頭，長度6~18，只包含字母、數字和下劃線"
              ></el-input>
            </el-form-item>
            <el-form-item prop="agreement" class="tips">
              <el-checkbox
                v-model="registerForm.agreement"
                label="勾選代表您同意"
                name="type"
              ></el-checkbox>
              <a
                href="https://api2.ts960.com/sztx/sztx-user.html"
                target="_blank"
                >《深圳台協網站用戶協議》</a
              >
            </el-form-item>
            <el-form-item class="btn">
              <el-button @click="register">註冊</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="手機號登錄" name="second" v-if="!isForget">
          <el-form
            ref="registerFormRef3"
            :model="registerForm"
            :rules="rules"
            label-width="0"
            class="login_form"
          >
            <el-form-item prop="userPhoneLogin">
              <el-input
                v-model="registerForm.userPhoneLogin"
                prefix-icon="el-icon-mobile-phone"
                placeholder="请請輸入您的手機號"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" v-if="!useCode">
              <el-input
                v-model="registerForm.password"
                type="password"
                prefix-icon="el-icon-lock"
                placeholder="請輸入您的密碼"
              ></el-input>
            </el-form-item>
            <el-form-item prop="verifyCode" class="code_input" v-else>
              <el-input
                v-model="registerForm.verifyCode"
                prefix-icon="el-icon-key"
                placeholder="請輸入動態密碼"
              ></el-input>
              <div
                class="code_btn"
                v-show="show"
                @click="fnGetVerificationCode(3)"
              >
                獲取驗證碼
              </div>
              <span v-show="!show" class="count">{{ count }}s後重新獲取</span>
            </el-form-item>
            <div class="remmber_btn">
              <div>
                <span @click="useCode = true" v-if="!useCode"
                  >短信驗證碼登錄</span
                >
                <span @click="useCode = false" v-else>帳號密碼登錄</span>
              </div>
              <div>
                <span @click="fnChangeIsForget">忘記密碼？</span
                ><span @click="activeName = 'first'">免費註冊</span>
              </div>
            </div>
            <el-form-item class="btn">
              <el-button @click="fnToLogin">登錄</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="忘記密碼" name="first" v-if="isForget">
          <el-form
            ref="registerFormRef2"
            :model="registerForm"
            :rules="rules"
            label-width="0"
            class="login_form"
          >
            <el-form-item prop="userPhoneLogin">
              <el-input
                v-model="registerForm.userPhoneLogin"
                prefix-icon="el-icon-mobile-phone"
                placeholder="请請輸入您的手機號"
              ></el-input>
            </el-form-item>
            <el-form-item prop="verifyCode" class="code_input">
              <el-input
                v-model="registerForm.verifyCode"
                prefix-icon="el-icon-key"
                placeholder="請輸入動態密碼"
              ></el-input>
              <div
                class="code_btn"
                v-show="show"
                @click="fnGetVerificationCode(2)"
              >
                获取验证码
              </div>
              <span v-show="!show" class="count">{{ count }}s后重新获取</span>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="registerForm.password"
                type="password"
                prefix-icon="el-icon-lock"
                placeholder="請重設密碼"
              ></el-input>
            </el-form-item>
            <div class="remmber_btn">
              <div>
                <span @click="fnChangeCodeLogin">短信驗證碼登錄 </span>
                <span @click="fnchangePasswordLogin"> 帳號密碼登錄</span>
              </div>
              <div><span @click="fnChangeRegister">免費註冊</span></div>
            </div>
            <el-form-item class="btn">
              <el-button @click="fnModifyPassword">修改密碼</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    const validatePhone = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手機號不能為空"));
      } else {
        const reg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/;
        // console.log('sasaj======',reg.test(value));
        if (reg.test(value)) {
          // this.checkPhone()
          const { data: res } = await this.$http.post(`/api/v2/account/initVariable/${this.registerForm.userPhone}`)
          if(!res.sucess) return this.$message.error('獲取失敗')
          if(res.code==='403') return callback(new Error("該手機號已經註冊過，請更換手機號或直擊登錄"));
          // console.log('sdhjdhsjd=====',res)
          callback();
        } else {
          return callback(new Error("請輸入正確的手機號"));
        }
      }
    };
    // 设置密码的验证规则
    const checkPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入密碼'))
      } else {
        const reg = /^[a-zA-Z]\w{5,17}$/
        if (reg.test(value)) {
          callback();
        }else {
          return callback(new Error("密碼以字母開頭，長度6~18，只包含字母、數字和下劃線"));
        }
      }
    }
    // 设置协议规则
    const checkAgreement = (rule, value, callback) => {
      // console.log(value)
      if (!value) {
        callback(new Error('請先閱讀協議並勾選'))
      } else {
        callback();
      }
    }
    const validatePhoneLogin = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手機號不能為空"));
      } else {
        const reg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/;
        // console.log('fggfgssaj======',reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("請輸入正確的手機號"));
        }
      }
    };
    return {
      activeName: "second",
      useCode: true, //登录验证码登录不显示
      isForget: false, //是否忘记密码
      show: true,
      count: "",
      timer: null,
      registerForm: {
        userPhone: "",
        verifyCode: "",
        password: "",
        agreement: false,
        userPhoneLogin: "",
      },
      rules: {
        userPhone: [
          { required: true, message: "請輸入手機號", trigger: "blur" },
          { validator: validatePhone, trigger: ['blur', 'change'] }
        ],
        verifyCode:[
          {required: true, message: "請輸入驗證碼", trigger: "blur" },
          { min: 6, max: 6, message: '驗證碼錯誤', trigger: 'blur' }
        ],
        // 密码
        password: [
          { required: true, message: "請輸入密碼", trigger: 'blur' },
          { min: 6, max: 18, message: '長度在 6 到 18 位', trigger: 'change' },
          {validator: checkPass, trigger: 'change'}
        ],
        agreement:[
          { required: true, validator:checkAgreement,message: "請先閱讀協議並勾選", trigger: 'change' },
        ],
        userPhoneLogin: [
          { required: true, message: "請輸入手機號", trigger: "blur" },
          { validator: validatePhoneLogin, trigger: ['blur', 'change'] }
        ],
      },
      activePath: "0",
    };
  },
  computed: {
    ...mapState(["headerMenuList", "infoRes", "validToken", "userInfo"]),
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    //短信验证码登录
    fnChangeCodeLogin() {
      this.isForget = false;
      this.activeName = "second";
      this.useCode = true;
    },
    //账号密码登录
    fnchangePasswordLogin() {
      this.isForget = false;
      this.activeName = "second";
      this.useCode = false;
    },
    //免费注册
    fnChangeRegister() {
      this.isForget = false;
      this.activeName = "first";
    },
    //忘记密码
    fnChangeIsForget() {
      this.isForget = true;
      this.activeName = "first";
    },
    //获取验证码
    fnGetVerificationCode(th) {
      let paramsName = th == 1 ? "userPhone" : "userPhoneLogin";
      // console.log(this.$refs)
      this.$refs["registerFormRef" + th].validateField(
        paramsName,
        async (valid) => {
          if (valid) return;
          // console.log(valid)
          const { data: res } = await this.$http.get(
            `api/v2/account/${this.registerForm[paramsName]}`
          );
          if (!res.sucess) return this.$message.error("获取失败");
          this.$message.success("获取成功");
          // console.log(res)
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          // window.sessionStorage.setItem('token',333)
          // this.$router.push('/home')
        }
      );
      //window.sessionStorage.clear  ====清空token
    },
    //注册
    register() {
      this.$refs.registerFormRef.validate(async (valid) => {
        if (!valid) return;
        // console.log(valid)
        const { data: res } = await this.$http.post(
          `/api/v2/account/init/${this.registerForm.userPhone}/${this.registerForm.verifyCode}?password=${this.registerForm.password}`
        );
        // console.log('注册=====',res)
        if (!res.sucess) return this.$message.error("注册失败，请稍后重试");
        this.$message.success("注册成功，请登录");
        this.fnchangePasswordLogin();
        window.sessionStorage.setItem("token", res.data);
      });
    },
    //登录
    fnToLogin() {
      this.$refs.registerFormRef3.validateField(
        "userPhoneLogin",
        async (valid) => {
          if (valid) return;
          // console.log('验证手机号=====',valid)
          let url = !this.useCode
            ? `api/v2/account/pcLogin/${this.registerForm.userPhoneLogin}/1?password=${this.registerForm.password}`
            : `api/v2/account/pcLogin/${this.registerForm.userPhoneLogin}/2?password=${this.registerForm.verifyCode}`;
          const { data: res } = await this.$http.post(url);
          if (!res.sucess) return this.$message.error("登录失败");
          if (res.code == 400) return this.$message.error(res.msg);
          // console.log('dl=====',res)
          window.sessionStorage.setItem("token", res.data);
          this.$message.success("登录成功");
          this.$router.go(-1);
          this.$store.dispatch("checkToken");
          // window.sessionStorage.setItem('token',333)
          // this.$router.push('/home')
        }
      );
    },
    //修改密码
    fnModifyPassword() {
      this.$refs.registerFormRef2.validate(async (valid) => {
        // console.log('验证修改密码=====',valid)
        if (!valid) return;
        const { data: res } = await this.$http.post(
          `api/v2/account/updatePwd/${this.registerForm.userPhoneLogin}/${this.registerForm.verifyCode}?password=${this.registerForm.password}`
        );
        // console.log('修改密码=====',res)
        if (!res.sucess) return this.$message.error("修改密码失败，请稍后重试");
        this.$message.success("修改密码成功，请重新登录");
        this.fnchangePasswordLogin();
        window.sessionStorage.setItem("token", res.data);
      });
    },
    //验证手机号是否已经注册过
    async checkPhone() {
      const { data: res } = await this.$http.post(
        `/api/v2/account/initVariable/${this.registerForm.userPhone}`
      );
      if (!res.sucess) return this.$message.error("获取失败");
      // console.log('zsqqq=====',res)
      // console.log(this)
      // return callback(new Error("手机号已注册过，请登录"))
    },
  },
};
</script>

<style lang="less" scoped>
.login_container {
  height: 100%;
  // background: rgba(0, 0, 0, 0.75);
}
.login_box {
  // width: 600px;
  // height: 526px;
  // background: #f1f3f4;
  // border-radius: 8px;
  // position: absolute;
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -50%);
  .avatar_box {
    width: 273px;
    height: 68px;
    margin: auto;
    padding-top: 22px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
/deep/ .tabs_menu {
  .el-tabs__header {
    padding: 0 20px;
  }
  .el-tabs__nav {
    width: 100% !important;
    margin-top: 6px;
  }
  .el-tabs__active-bar {
    width: 50% !important;
  }
  .el-tabs__item {
    width: 50% !important;
    text-align: center;
    font-size: 20px;
    padding: 20px;
    height: auto;
    line-height: 20px;
  }
  .el-tabs__item:hover {
    color: #4f4e95 !important;
  }
  .el-tabs__item.is-active {
    color: #4f4e95 !important;
  }
  .el-tabs__active-bar {
    background-color: #4f4e95 !important;
  }
  .el-tabs__content {
    position: static !important;
  }
}
/deep/ .login_form {
  // position: absolute;
  // top: 140px;
  width: 100%;
  padding: 9px 20px 0;
  box-sizing: border-box;
  .el-form-item {
    margin-bottom: 15px;
  }
  .el-input {
    font-size: 16px !important;
  }
  .el-input__inner {
    border: none;
    border-bottom: 1px solid #d6d5d5;
    background-color: transparent;
    color: #000;
    border-radius: 0;
  }
}
/deep/ .code_input {
  .el-form-item__content {
    position: relative;
  }

  .code_btn {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 16px;
    color: #4f4e95;
    cursor: pointer;
  }
  .count {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 16px;
    color: #ccc;
  }
}
/deep/ .tips {
  font-size: 12px;
  color: rgba(0, 0, 0, 1);
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #4f4e95 !important;
    border-color: #4f4e95 !important;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #4f4e95 !important;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #4f4e95 !important;
  }
}
.remmber_btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    margin-top: 10px;
    font-size: 14px;
    color: #000;
  }
  span:hover {
    color: #4f4e95;
    text-decoration: underline;
    cursor: pointer;
  }
}

.btn {
  width: 271px;
  height: 45px;
  margin: auto;
  position: absolute;
  left: 50%;
  bottom: 53px;
  transform: translate(-50%, 0);
  button {
    width: 100%;
    height: 100%;
    border-radius: 45px;
    line-height: 45px;
    background: #394599;
    color: #ffffff;
    padding: 0;
    font-size: 16px;
  }
}
</style>
